<template>

  <div
    v-if="visible"
    class="contact-us px-2 py-2 box-shadow bg-dark-gray c-almost-white"
  >
    
    <h1 class="strong fs-lg c-light-gray">Contact Us</h1>

    <p class="mt-2">
      
      <label
        for="contact-name"
        class="fs-sm c-light-gray"
      >
        Your Name
      </label>

      <input type="text"
        class="b ba bc-medium-gray width-20 mt-1_2 bg-almost-white"
        v-model="contactName"
        name="contact-name"
      />
    </p>
    
    <p class="mt-1">
      
      <label
        for="contact-email"
        class="fs-sm c-light-gray"
      >
        Your Email
      </label>

      <input type="email"
        class="b ba bc-medium-gray width-20 mt-1_2 bg-almost-white"
        v-model="contactEmail"
        name="contact-email"
      />
    </p>

    <p class="mt-1">
      
      <label
        for="message"
        class="fs-sm c-light-gray"
      >
        Message
      </label>

      <textarea
        class="b ba bc-medium-gray width-20 height-10 mt-1_2 bg-almost-white"
        v-model="message"
        name="message"
      >          
      </textarea>
    </p>
    
    <p
      v-if="messageSubmitted"
      class="mt-1"
    >
      Thank you for your message.
    </p>

    <p class="mt-1">
      <input
        type="submit"
        class="bg-green c-almost-white b ba bc-medium-gray px-1 py-1_2 width-5 pointer"
        value="Send"
        @click="submit"
      />
      <input
        type="cancel"
        class="bg-medium-gray c-dark-gray b ba bc-medium-gray px-1 py-1_2 ml-1 width-5 pointer"
        value="Cancel"
        @click="cancel"
      />      
    </p>
  </div><!-- .contact-us -->

</template>

<script>
import { mapGetters } from 'vuex';  
import { doLogging }  from '../modules/log';

export default {

  name: 'ContactUs',

  props: {
    visible: { type: Boolean, required: true }
  },

  data () {
    return {
      contactName: '',
      contactEmail: '',
      message: '',
      messageSubmitted: false,
    };
  },

  computed: {

    ...mapGetters([
      'loggingContext',
    ]),

    messageContent () {

      return JSON.stringify({
        contactName: this.contactName,
        contactEmail: this.contactEmail,
        message: this.message
      });
    },
  },

  methods: {

    resetFormFields () {
      this.contactName = '';
      this.contactEmail = '';
      this.message = '';
    },

    cancel () {
        this.resetFormFields();
        this.$emit( 'close' );
    },

    submit () {
      
      const event = {
        eventType: 'contact',
        eventDetails: this.messageContent,
        ...this.loggingContext
      };

      doLogging( event );
      
      this.messageSubmitted = true;

      setTimeout( () => {
        this.messageSubmitted = false;
        this.resetFormFields();
        this.$emit( 'close' );
      }, 2000 );
    },
  }
};
</script>

<style lang="scss">

.contact-us {
  position: absolute;
  left: 50%;
  top: 150px;
  transform: translate( -50% );

  label { display: block; }
  textarea{ font-size: 1rem; }

  input[type=submit]:hover,
  input[type=cancel]:hover {
    border-color: white;
  }
}

</style>
